/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-17T17:39:58.445
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportMonthRentContractUndue,
	getReportMonthRentContractUndueCreateInit,
	getReportMonthRentContractUndueEditInit,
	getReportMonthRentContractUndueView,
	deleteReportMonthRentContractUndue
} from '@api/report/ReportMonthRentContractUndue';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportMonthRentContractUndueCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentContractUndueCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportMonthRentContractUndueEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentContractUndueEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportMonthRentContractUndue({}, ReportMonthRentContractUndue) {
			return new Promise((resolve, reject) => {
				saveReportMonthRentContractUndue(ReportMonthRentContractUndue)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportMonthRentContractUndueView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentContractUndueView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportMonthRentContractUndue({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportMonthRentContractUndue({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
